import React from 'react';
import LegalPage from './components/LegalPage';
import { PRIVACY_POLICY_HTML } from './data/legalContent';

export default function PrivacyPolicyPage() {
  return <LegalPage title="Privacy Policy" html={PRIVACY_POLICY_HTML} />;
}
